module.exports = __webpack_public_path__ + "static/media/instagram-512x512.97d79124.png";